<template>
  <unicom-modal-acao
    v-model="valueData"
    textoTitulo="Reprovar o arquivo?"
    :mensagem="mensagemReprovar"
    textoBotaoConfirmar="REPROVAR"
    tipoBotao="importante"
    :larguraModal="506"
    :larguraBotaoConfirmar="157"
    @botao-confirmar="$emit('botao-confirmar')"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },

    possuiAlgumErroConsiderado: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      valueData: false
    };
  },

  computed: {
    mensagemReprovar() {
      return this.possuiAlgumErroConsiderado
        ? "Após reprovado, a singular será informada dos erros identificados."
        : "Não foi identificado nenhum erro.";
    }
  },

  watch: {
    value() {
      this.valueData = this.value;
    },
    valueData() {
      this.$emit("input", this.valueData);
    }
  }
};
</script>
